import {
  BonusPointsMetadata,
  CampaignPointsMetadata,
  CardLinkedOfferMetadata,
  CardSpendMetadata,
  GiftCardMetadata,
  ManualAdjustmentMetadata,
  PointsTransferMetadata,
  RedeemCashMetadata,
  RefundMetadata,
  SharePointsMetadata,
  SystemEventMetadata,
  TravelCarMetadata,
  TravelFlightMetadata,
  TravelHotelMetadata,
} from './points-transaction-metadata.type';
import { ProductCategory } from './product-category.type';

export enum PointsTransactionCategory {
  Accrual = 'accrual',
  Redemption = 'redemption',
  Refund = 'refund',
  Reversal = 'reversal',
  Expiry = 'expiry',
  WriteOff = 'write_off',
  WriteOffNegative = 'write_off_negative',
}

export enum PointsTransactionStatus {
  Confirmed = 'confirmed',
  Failed = 'failed',
  Pending = 'pending',
  Processing = 'processing',
}

export enum PointsTransactionProductType {
  Merchandise = 'merchandise',
  TravelBooking = 'travel_booking',
  PointsTransfer = 'points_transfer',
  CardSpend = 'card_spend',
  EventBased = 'event_based',
  GiftCard = 'gift_card',
  SystemEvent = 'system_event',
  ManualAdjustment = 'manual_adjustment',
  CampaignPoints = 'campaign_points',
  CashRedemption = 'cash_redemption',
  PurchaseEraser = 'purchase_eraser',
  CardLinkedOffer = 'card_linked_offer',
  PointsShare = 'points_share',
  AffiliateMall = 'affiliate_mall',
  RealtimeCardSpend = 'realtime_card_spend',
  MigratedBalance = 'migrated_balance',
  AnnualFee = 'annual_fee',
  PhysicalGiftCard = 'physical_gift_card',
  ShoppingCart = 'shopping_cart',
  Reward = 'reward',
  PartnerAdjustment = 'partner_adjustment',
}

// TODO: Consolidate this with OrderItemStatus as they are the same thing.
// This is in the PT type because this field is only exposed in the PointsTransaction endpoint, not in Orders endpoint.
export enum OrderFulfillmentStatus {
  Cancelled = 'cancelled',
  Fulfilled = 'fulfilled',
  Failed = 'failed',
  Pending = 'pending',
  Processing = 'processing',
}

export interface PointsTransaction {
  amount: number;
  balance: number | null;
  category: PointsTransactionCategory;
  confirmedAt?: Date;
  createdAt: Date;
  descriptor: string;
  id: string;
  status: PointsTransactionStatus;
  orderFulfillmentStatus: OrderFulfillmentStatus;
  productType: ProductCategory;
  transactionTime: Date;
  // TODO: confirm with Huy all possible value
  entryType?: 'credit' | 'debit';
  metadata:
    | BonusPointsMetadata
    | CampaignPointsMetadata
    | CardSpendMetadata
    | CardLinkedOfferMetadata
    | GiftCardMetadata
    | ManualAdjustmentMetadata
    | PointsTransferMetadata
    | RedeemCashMetadata
    | TravelHotelMetadata
    | TravelCarMetadata
    | TravelFlightMetadata
    | RefundMetadata
    | SharePointsMetadata
    | {};
  orderItemData?:
    | BonusPointsMetadata
    | CampaignPointsMetadata
    | CardSpendMetadata
    | CardLinkedOfferMetadata
    | GiftCardMetadata
    | ManualAdjustmentMetadata
    | PointsTransferMetadata
    | RedeemCashMetadata
    | TravelHotelMetadata
    | TravelCarMetadata
    | TravelFlightMetadata
    | RefundMetadata
    | SharePointsMetadata
    | {};
  pointsStatementId?: string;
  orderId?: string;
}

export interface RedeemCashPointsTransaction extends PointsTransaction {
  metadata: RedeemCashMetadata;
  orderItemData: RedeemCashMetadata;
}

export interface ManualAdjustmentPointsTransaction extends PointsTransaction {
  productType: ProductCategory.ManualAdjustment;
  metadata: ManualAdjustmentMetadata;
  orderItemData: ManualAdjustmentMetadata;
}

export interface SystemEventPointsTransaction extends PointsTransaction {
  productType: ProductCategory.SystemEvent;
  metadata: SystemEventMetadata;
}

export interface PointsTransferPointsTransaction extends PointsTransaction {
  metadata: PointsTransferMetadata;
  orderItemData: PointsTransferMetadata;
}
